import {
  type FC
} from 'react';
import {
  Button as JoyButton,
} from '@mui/joy';
import {
  type ButtonProps
} from './types';

export const Button: FC<ButtonProps> = ({ children, sx, ...props }: ButtonProps) => (
  <JoyButton
    {...props}
    sx={[
      { width: 'fit-content' },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}>
    {children}
  </JoyButton>
);
